import { defineMessages } from "react-intl";

const messages = defineMessages({
  maxRoomsMsg: {
    id: "hotel.searchForm.maxRoomsMsg",
    description:
      "A message informing the user that the maximum number of rooms has been added. The user needs to contact the property directly if they wish to book for more guests.",
    defaultMessage:
      "To book more than {MAX_ROOMS} rooms, contact the property directly.",
  },
  maxChildrenInRoomMsg: {
    id: "hotel.searchForm.maxChildrenInRoomMsg",
    description:
      "A message informing the user that their selection has exceeded the maximum number of children possible to stay in a room. The user needs to add a new room. ",
    defaultMessage:
      "Only {MAX_CHILDREN_IN_ROOM} or less children under 18 years old can stay in this room. Try choosing multiple rooms.",
  },
  maxGuestsInRoomMsg: {
    id: "hotel.searchForm.maxGuestsInRoomMsg",
    description:
      "A message informing the user that their selection has exceeded the maximum number of guests possible to stay in a room. The user needs to add a new room.",
    defaultMessage:
      "Only {MAX_GUESTS_IN_ROOM} or less guests can stay in this room. Try choosing multiple rooms.",
  },
  maxAdultsInBookingMsg: {
    id: "hotel.searchForm.maxAdultsInBookingMsg",
    description:
      "A message informing the user that the maximum number of adults for all rooms combined together has been reached. The user needs to contact the property directly if they wish to book for more adults.",
    defaultMessage:
      "To make a booking for {MAX_ADULTS} adults or more, contact the property directly.",
  },
  maxChildrenInBookingMsg: {
    id: "hotel.searchForm.maxChildrenInBookingMsg",
    description:
      "A message informing the user that the maximum number of children for all rooms combined together has been reached. The user needs to contact the property directly if they wish to book for more children.",
    defaultMessage:
      "To make a booking for {MAX_CHILDREN} children or more, contact the property directly.",
  },
  maxGuestsMsg: {
    id: "hotel.searchForm.maxGuestsMsg",
    description:
      "A message informing the user that the maximum number of guests for all rooms combined together has been reached. The user needs to contact the property directly if they wish to book for more guests.",
    defaultMessage:
      "To make a booking for {MAX_GUESTS} guests or more, contact the property directly.",
  },
  childAgeNeededReason: {
    id: "hotel.searchForm.childAgeNeededReason",
    description:
      "A description of why we need the children's ages for the hotel search",
    defaultMessage:
      "Please provide the ages of children, so we can choose appropriate rooms.",
  },
});

export default messages;
